<template>
<div class="q-numeric textfield columns is-mobile is-gapless"
style="margin: 4px; padding: 4px 0; margin-bottom: 8px">
  <input
  class="no-style q-input-field column"
  @change="onChange"
  :value="value">
  <div class="column is-narrow" style="padding: 0 2px;">
    <button class="primary square"
    @mousedown="dec"
    @mouseup="stop"
    @touchstart.prevent="dec"
    @touchend.prevent="stop"
    @touchcancel.prevent="stop"
    @touchleave.prevent="stop"
    >
      <i class="material-icons">&#xE15B;</i>
    </button> 
  </div>
  <div class="column is-narrow" style="padding: 0 2px;">
    <button class="primary square"
    @mousedown="inc"
    @mouseup="stop"
    @touchstart.prevent="inc"
    @touchend.prevent="stop"
    @touchcancel.prevent="stop"
    @touchleave.prevent="stop"
    >
      <i class="material-icons">&#xE145;</i>
    </button>
  </div>
</div>
</template>

<script>
'use strict'

// var rAF = window.requestAnimationFrame ||
//   window.webkitRequestAnimationFrame ||
//   window.mozRequestAnimationFrame ||
//   window.oRequestAnimationFrame ||
//   window.msRequestAnimationFrame ||
//   function (callback) { window.setTimeout(callback, 1000 / 60) }

function min_to_time (minutes) {
  return ('0' + Math.floor(minutes / 60)).substr(-2) + ':' + ('0' + (minutes % 60)).substr(-2)
}

function time_to_min (time) {
  var tmp = time.split(':')
  if (tmp.length > 0) {
    return (parseInt(tmp[0]) * 60 + parseInt(tmp[1]) % 60) % 1440
  }
  else {
    return parseInt(tmp[1])
  }
}

export default {
  name: 'time-input',
  props: {
    val: {
      // required: true,
      default: 0
    },
    value: {
      required: true,
      default: 0
    }
    // delay: {
    //   default: 300
    // },
    // delay_step: {
    //   default: 30
    // },
    // value_step: {
    //   default: 1
    // },
    // delay_step_min: {
    //   default:100
    // },
    // model: {
    //   default: 0
    // }
  },
  data () {
    return {
      initial_delay: 500,
      delay: 300,
      delay_step: 25,
      delay_step_min: 50,
      value_step: 1
      // model: 0
    }
  },
  // computed: {
  //   time: function()  {
  //     return ("0"+Math.floor(this.value/60)).substr(-2)+":"+("0"+(this.value%60)).substr(-2)
  //   },

  //   model: {
  //     get () {
  //       return this.value
  //     },
  //     set (value) {

  //     }
  //   }
  // },
  methods: {
    dec: function () {
      // console.log('dec')
      if (!this.stoped) return
      this.stoped = false
      let vm = this
      this.direction = -1
      this.cur_delay = this.delay
      this.set_value()
      setTimeout(function () {
        vm.change()
      }, vm.initial_delay)
    },

    inc: function () {
      // console.log('inc')
      if (!this.stoped) return
      this.stoped = false
      let vm = this
      this.direction = 1
      this.cur_delay = this.delay
      this.set_value()
      setTimeout(function () {
        vm.change()
      }, vm.initial_delay)
    },

    set_value: function () {
      let minutes = time_to_min(this.value)
      this.new_value = (minutes + this.value_step * this.direction) % 1440

      if (this.new_value < 0) {
        this.new_value = 0
        // this.new_value = 1440 - this.new_value
      }

      let new_time = min_to_time(this.new_value)

      if (new_time !== this.value) {
        this.$emit('input', new_time)
      }
    },

    change: function () {
      let vm = this
      if (!vm.stoped) {
        setTimeout(function () {
          if (!vm.stoped) {
            vm.set_value()
          }
        })

        if (this.cur_delay - this.delay_step > this.delay_step_min) {
          this.cur_delay -= this.delay_step
        }
        else {
          this.cur_delay -= this.delay_step_min
        }

        setTimeout(function () {
          if (!vm.stoped) {
            vm.change()
          }
        },
        this.cur_delay)
      }
    },

    stop: function () {
      // console.log('stop')
      this.stoped = true
    },

    onChange: function (e) {
      this.new_value = time_to_min(e.target.value)

      if (this.new_value < 0) {
        this.new_value = 0
      }

      var new_time = min_to_time(this.new_value)

      if (new_time !== this.value) {
        this.$emit('input', new_time)
      }
    }

  }
}
</script>

<style>
button.square {
  padding: 0.5rem 0.75rem;
}
</style>
